import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'forma-button-group',
  template: `
    <ng-content [select]="['forma-button']"></ng-content>
  `,
  styleUrls: ['./button-group.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.forma-button-group]': 'true',
    '[class.align-end]': "align() === 'end'",
    '[class.align-center]': "align() === 'center'",
  },
})
export class ButtonGroup {
  align = input<'start' | 'end' | 'center' | ''>('start');
}
